import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { formatDate } from "../../utils/formatDate"
// import MaterialAcceptanceDetailsModal from '../modal/MaterialAcceptanceDetailsModal';
const MaterialRequestModal = ({ show, handleClose, selectedId }) => {
  // const [materialAcceptanceDetails, setMaterialAcceptanceDetails] = useState(false)
  const [materialDetails, setMaterialDetails] = useState([])
  useEffect(() => {
    if (show && selectedId) {
      fetchDetails(selectedId);
    }
  }, [show, selectedId]);

  const fetchDetails = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/supervisor/materialissueshow/${selectedId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = response?.data || null;
      setMaterialDetails(result);
      console.log(result, "result")
    } catch (err) {
      console.error("Error fetching fetchDetails:", err.message);
      setMaterialDetails(null);
    }
  };


  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className='font_family'>
      <Modal.Body className='p-5'>
        <strong className='fs-3'>Material Request</strong>
        <div className="p-3 mt-3">
          <div className='bg-light p-3'>
            <Row className="mb-2 ">
              <Col>
                <strong>Request Information</strong>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <strong>Material Name:</strong> {materialDetails?.materialissueshow?.material_master?.material_name}
              </Col>
              <Col>
                <strong>Material ID:</strong> <span>{materialDetails?.materialissueshow?.material_master?.material_code}</span>
              </Col>

            </Row>
            <Row className="mb-4">
              <Col>
                <strong>Qty:</strong> {materialDetails?.materialissueshow?.quantity}
              </Col>
              <Col>
                {/* <strong>Date of Request:</strong> 12/03/2025 */}
                <strong>Date of Request:</strong> {formatDate(materialDetails?.materialissueshow?.created_at)}
              </Col>
            </Row>
          </div>
          <Row className="mt-3">
            <Col md={2}>
              Status
            </Col>
            <Col md={5}>
              <div className="border rounded p-2 bg-white">{materialDetails?.materialissueshow?.status}</div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={2}>
              Material Recieved
            </Col>
            <Col md={4}>
              <div className="border rounded p-2 bg-white">{materialDetails?.materialissueshow?.quantity}</div>
            </Col>
            <Col md={2}>
              Material pending
            </Col>
            <Col md={4}>
              <div className="border rounded p-2 bg-white">0.00</div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={2}>
              <Form.Label><strong>Notes</strong></Form.Label>
            </Col>
            <Col md={10}>
              <div className="border rounded p-3 bg-white">
                {materialDetails?.materialissueshow?.notes}
              </div>
            </Col>
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer className='border-0'>
        {/* <Button variant="secondary" onClick={() => setMaterialAcceptanceDetails(true)}>View Acceptance Report</Button> */}
        <Button variant="dark">Send Reminder</Button>
        <Button variant="outline-secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
      {/* <MaterialAcceptanceDetailsModal
        show={materialAcceptanceDetails}
        materialId={selectedId}
        handleClose={() => setMaterialAcceptanceDetails(false)}
      /> */}
    </Modal>
  );
};
export default MaterialRequestModal;
